var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        {
          attrs: { bordered: false, title: "期末处理（结转 · 结账 · 反结账）" },
        },
        [
          _c(
            "a-tabs",
            {
              on: { change: _vm.onTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "a-tab-pane",
                { key: "checkout", attrs: { tab: "期末结转" } },
                [
                  _c(
                    "a-steps",
                    {
                      staticStyle: { "margin-bottom": "24px" },
                      attrs: { current: _vm.step },
                    },
                    [
                      _c("a-step", { attrs: { title: "选择年月" } }),
                      _c("a-step", { attrs: { title: "结转处理" } }),
                      _c("a-step", { attrs: { title: "结账检查" } }),
                    ],
                    1
                  ),
                  _vm.step === 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "a-form",
                            {
                              staticStyle: { "margin-bottom": "16px" },
                              attrs: { layout: "inline" },
                            },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "结账期间" } },
                                [
                                  _c("a-month-picker", {
                                    staticStyle: { width: "160px" },
                                    attrs: { format: "YYYY-MM" },
                                    model: {
                                      value: _vm.periodMoment,
                                      callback: function ($$v) {
                                        _vm.periodMoment = $$v
                                      },
                                      expression: "periodMoment",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.goStep2 },
                                },
                                [_vm._v("下一步")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-descriptions",
                            {
                              staticStyle: { "max-width": "640px" },
                              attrs: {
                                title: "结账状态",
                                column: 2,
                                size: "small",
                                bordered: "",
                              },
                            },
                            [
                              _c(
                                "a-descriptions-item",
                                { attrs: { label: "启用月份" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.status.startYearMonth || "—")
                                  ),
                                ]
                              ),
                              _c(
                                "a-descriptions-item",
                                { attrs: { label: "当前期间" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.status.currentYearMonth || "—")
                                  ),
                                ]
                              ),
                              _c(
                                "a-descriptions-item",
                                { attrs: { label: "已结账至" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.status.closedThrough || "未结账")
                                  ),
                                ]
                              ),
                              _c(
                                "a-descriptions-item",
                                { attrs: { label: "可结账月份" } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#1890ff" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.status.nextCloseable || "—")
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "a-descriptions-item",
                                { attrs: { label: "已结账月份", span: 2 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.status.closedMonths &&
                                        _vm.status.closedMonths.length
                                        ? _vm.status.closedMonths.join("、")
                                        : "无"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.step === 1
                    ? _c(
                        "div",
                        [
                          _c("a-alert", {
                            staticStyle: { "margin-bottom": "12px" },
                            attrs: {
                              type: "info",
                              "show-icon": "",
                              message:
                                "凭证行只暂存在页面内存中，点最后一步「结账」才一次性生成并审核；中途上一步/关闭页面不产生任何数据。",
                            },
                          }),
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "12px" } },
                            [
                              _c("span", [
                                _vm._v("结账期间："),
                                _c("b", [_vm._v(_vm._s(_vm.period))]),
                              ]),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "24px" } },
                                [
                                  _vm._v("所得税率档：\n              "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      on: { change: _vm.loadCards },
                                      model: {
                                        value: _vm.rateKey,
                                        callback: function ($$v) {
                                          _vm.rateKey = $$v
                                        },
                                        expression: "rateKey",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio",
                                        { attrs: { value: "standard" } },
                                        [_vm._v("标准 25%")]
                                      ),
                                      _c(
                                        "a-radio",
                                        { attrs: { value: "small" } },
                                        [_vm._v("小微 5%")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "a-row",
                            { attrs: { gutter: 12, type: "flex" } },
                            _vm._l(_vm.cards, function (c) {
                              return _c(
                                "a-col",
                                {
                                  key: c.key,
                                  staticStyle: { "margin-bottom": "12px" },
                                  attrs: { md: 6, sm: 24 },
                                },
                                [
                                  _c(
                                    "a-card",
                                    {
                                      class: { "gl-card-disabled": !c.enabled },
                                      attrs: { size: "small" },
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "title" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(c.name) +
                                              "\n                  "
                                          ),
                                          c.type === "profit"
                                            ? _c(
                                                "a-tag",
                                                { attrs: { color: "blue" } },
                                                [_vm._v("结账时自动")]
                                              )
                                            : _vm.configuredCards[c.key]
                                            ? _c(
                                                "a-tag",
                                                { attrs: { color: "green" } },
                                                [_vm._v("已暂存")]
                                              )
                                            : _vm.isAutoCard(c)
                                            ? _c(
                                                "a-tag",
                                                { attrs: { color: "blue" } },
                                                [_vm._v("自动测算")]
                                              )
                                            : _c(
                                                "a-tag",
                                                { attrs: { color: "orange" } },
                                                [_vm._v("手工填写")]
                                              ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            height: "48px",
                                            overflow: "hidden",
                                          },
                                        },
                                        [_vm._v(_vm._s(c.reason))]
                                      ),
                                      _c(
                                        "div",
                                        { staticStyle: { margin: "4px 0" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "18px",
                                                "font-weight": "600",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.fmtAmount(c.amount))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#999",
                                            "font-size": "12px",
                                            height: "18px",
                                            overflow: "hidden",
                                            "text-overflow": "ellipsis",
                                            "white-space": "nowrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              (c.subjects || [])
                                                .filter(Boolean)
                                                .join(" / ")
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-top": "8px",
                                            height: "24px",
                                          },
                                        },
                                        [
                                          c.type === "profit"
                                            ? _c(
                                                "a-button",
                                                {
                                                  attrs: { size: "small" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openCard(c)
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看凭证")]
                                              )
                                            : _c(
                                                "a-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openCard(c)
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.configuredCards[c.key]
                                                        ? "修改"
                                                        : "暂存凭证"
                                                    )
                                                  ),
                                                ]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-right": "8px" },
                              on: {
                                click: function ($event) {
                                  _vm.step = 0
                                },
                              },
                            },
                            [_vm._v("上一步")]
                          ),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.goStep3 },
                            },
                            [_vm._v("下一步")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.step === 2
                    ? _c(
                        "div",
                        [
                          _c("a-list", {
                            staticStyle: { "max-width": "640px" },
                            attrs: {
                              size: "small",
                              bordered: "",
                              loading: _vm.checking,
                              "data-source": _vm.checks,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "renderItem",
                                  fn: function (c) {
                                    return _c(
                                      "a-list-item",
                                      {},
                                      [
                                        _c("a-icon", {
                                          staticStyle: {
                                            "margin-right": "8px",
                                          },
                                          attrs: {
                                            type: c.pass
                                              ? "check-circle"
                                              : "close-circle",
                                            theme: c.pass
                                              ? "twoTone"
                                              : "filled",
                                            "two-tone-color": c.pass
                                              ? "#52c41a"
                                              : "#f5222d",
                                          },
                                        }),
                                        _c("b", [_vm._v(_vm._s(c.title))]),
                                        _vm._v(
                                          "：" +
                                            _vm._s(c.detail) +
                                            "\n            "
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              2517153727
                            ),
                          }),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "16px" } },
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-right": "8px" },
                                  on: {
                                    click: function ($event) {
                                      _vm.step = 1
                                    },
                                  },
                                },
                                [_vm._v("上一步")]
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.closing,
                                    disabled: !_vm.allChecksPassed,
                                  },
                                  on: { click: _vm.doClose },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.period && _vm.period.endsWith("-12")
                                        ? "年结（结账）"
                                        : "结账"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.closeResult
                            ? _c(
                                "a-result",
                                {
                                  staticStyle: { "max-width": "640px" },
                                  attrs: {
                                    status: _vm.closeResult.success
                                      ? "success"
                                      : "error",
                                    title: _vm.closeResult.message,
                                  },
                                },
                                [
                                  _c("template", { slot: "extra" }, [
                                    _vm.closeResult.cardCount
                                      ? _c("span", [
                                          _vm._v(
                                            "结转卡片凭证 " +
                                              _vm._s(
                                                _vm.closeResult.cardCount
                                              ) +
                                              " 张　"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.closeResult.carryVoucherId
                                      ? _c("span", [
                                          _vm._v(
                                            "损益结转凭证 #" +
                                              _vm._s(
                                                _vm.closeResult.carryVoucherId
                                              ) +
                                              "　"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.closeResult.profitVoucherId
                                      ? _c("span", [
                                          _vm._v(
                                            "利润分配凭证 #" +
                                              _vm._s(
                                                _vm.closeResult.profitVoucherId
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "unclose", attrs: { tab: "反结账" } },
                [
                  _c(
                    "a-form",
                    {
                      staticStyle: { "margin-bottom": "16px" },
                      attrs: { layout: "inline" },
                    },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "选择已结账月份" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "160px" },
                              attrs: { placeholder: "选择月份" },
                              model: {
                                value: _vm.unclosePeriod,
                                callback: function ($$v) {
                                  _vm.unclosePeriod = $$v
                                },
                                expression: "unclosePeriod",
                              },
                            },
                            _vm._l(_vm.status.closedMonths || [], function (m) {
                              return _c(
                                "a-select-option",
                                { key: m, attrs: { value: m } },
                                [_vm._v(_vm._s(m))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "danger", loading: _vm.unclosing },
                          on: { click: _vm.doUnclose },
                        },
                        [_vm._v("反结账")]
                      ),
                    ],
                    1
                  ),
                  _c("a-alert", {
                    attrs: {
                      type: "warning",
                      "show-icon": "",
                      message:
                        "反结账规则：仅允许反结账最后一个已结账月份；执行时删除该期结转凭证、解锁期间并回退账套当前期间，其后未结账月份的凭证保留不动。",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("voucher-editor", {
        attrs: {
          visible: _vm.editorVisible,
          mode: _vm.editorMode,
          "account-set-id": _vm.accountSetId,
          period: _vm.period,
          "memory-mode": true,
          "prefill-items": _vm.editorPrefill,
        },
        on: {
          "update:visible": (v) => (_vm.editorVisible = v),
          confirm: _vm.onCardConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }